var MainStaticPage = /** @class */ (function () {
    function MainStaticPage(obj, id) {
        if (id) {
            this.id = id;
        }
        this.bg_name = obj.bg_name;
        this.en_name = obj.en_name;
        this.slug = obj.slug;
        this.page_type = obj.page_type;
        this.position = obj.position;
        this.bg_description = obj.bg_description;
        this.bg_description_json = obj.bg_description_json;
        this.en_description = obj.en_description;
        this.en_description_json = obj.en_description_json;
        this.canonical_url = obj.canonical_url;
    }
    Object.defineProperty(MainStaticPage.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStaticPage.prototype, "BgName", {
        get: function () {
            return this.bg_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStaticPage.prototype, "EnName", {
        get: function () {
            return this.en_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStaticPage.prototype, "Slug", {
        get: function () {
            return this.slug;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStaticPage.prototype, "PageType", {
        get: function () {
            return this.page_type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStaticPage.prototype, "Position", {
        get: function () {
            return this.position;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStaticPage.prototype, "BgDescription", {
        get: function () {
            return this.bg_description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStaticPage.prototype, "BgDescriptionJson", {
        get: function () {
            return this.bg_description_json;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStaticPage.prototype, "EnDescription", {
        get: function () {
            return this.en_description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStaticPage.prototype, "EnDescriptionJson", {
        get: function () {
            return this.en_description_json;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStaticPage.prototype, "CanonicalUrl", {
        get: function () {
            return this.canonical_url;
        },
        enumerable: false,
        configurable: true
    });
    return MainStaticPage;
}());
export { MainStaticPage };
export function createMainStaticPage(obj, id) {
    return new MainStaticPage(obj, id);
}
export function createMainStaticPages(rawMainStaticPages) {
    var mainStaticPages = [];
    var rawMainStaticPagesData = rawMainStaticPages.data;
    for (var _i = 0, rawMainStaticPagesData_1 = rawMainStaticPagesData; _i < rawMainStaticPagesData_1.length; _i++) {
        var rawMainStaticPage = rawMainStaticPagesData_1[_i];
        var mainStaticPage = createMainStaticPage(rawMainStaticPage.attributes, rawMainStaticPage.id);
        mainStaticPages.push(mainStaticPage);
    }
    return mainStaticPages;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/mainStaticPage/mainStaticPage.ts
// module id = 119
// module chunks = 0